import { AppConfig } from '@/types';
import { warnLog } from '@/utils/logger';

export const config: AppConfig = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || '/api',
  googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID,
  blockchain: {
    chainId: parseInt(import.meta.env.VITE_CHAIN_ID || '31337'),
    rpcUrl: import.meta.env.VITE_RPC_URL || 'https://rpc.heperum.org/rpc',
    explorerUrl: import.meta.env.VITE_BLOCK_EXPLORER_URL || 'https://block.heperum.org',
    tokenSymbol: import.meta.env.VITE_TOKEN_SYMBOL || 'HEP',
    nativeCurrencyName: import.meta.env.VITE_NATIVE_CURRENCY_NAME || 'Heperum Mainnet',
    nativeCurrencySymbol: import.meta.env.VITE_NATIVE_CURRENCY_SYMBOL || 'MST',
  },
  appName: import.meta.env.VITE_APP_NAME || 'Heperum',
  version: import.meta.env.VITE_APP_VERSION || '1.0.0',
};

// Validate required configuration
const validateConfig = () => {
  if (!config.apiBaseUrl) {
    warnLog('⚠️ VITE_API_BASE_URL not configured, using default');
  }
  
  if (!config.googleClientId && import.meta.env.PROD) {
    warnLog('⚠️ Google OAuth not configured for production');
  }
};

validateConfig();